import { Keyboard } from "lucide-react";
import type { Instrument } from "../data/instruments";
import { useI18n } from "../i18n/LocaleContext";
import { getKeyboardPerformanceMappings } from "../lib/keyboardPerformance";

interface KeyboardMappingPanelProps {
  instrument: Instrument;
  pressedKeys: string[];
  compact?: boolean;
}

export function KeyboardMappingPanel({ instrument, pressedKeys, compact = false }: KeyboardMappingPanelProps) {
  const { t } = useI18n();
  const mappings = getKeyboardPerformanceMappings(instrument);

  return (
    <div className={`keyboard-map ${compact ? "is-compact" : ""}`} aria-label={`${instrument.name} keyboard mapping`} data-testid="keyboard-mapping-panel">
      <div className="keyboard-map-heading">
        <Keyboard size={18} aria-hidden="true" />
        <span>ASDF JKL;</span>
      </div>
      <div className="keyboard-key-grid">
        {mappings.map((mapping) => (
          <span
            key={mapping.key}
            className={`keyboard-key ${pressedKeys.includes(mapping.key) ? "is-active" : ""}`}
            data-testid={`keyboard-key-${mapping.key === ";" ? "semicolon" : mapping.key}`}
          >
            <kbd>{mapping.label}</kbd>
            <small>{compact ? mapping.role : `${mapping.role} / Shift: ${mapping.shiftRole}`}</small>
          </span>
        ))}
      </div>
      {!compact ? (
        <p className="keyboard-modifier-row">
          <span>{t.keyboard.shift}</span>
          <span>{t.keyboard.space}</span>
          <span>{t.keyboard.arrows}</span>
          <span>{t.keyboard.numbers}</span>
        </p>
      ) : null}
    </div>
  );
}
